export const mentorConstraints = [{}] as MediaTrackConstraintSet[];

export const clientConstraints = {
    "GALAXY S7": [
        {
            width: 640,
            height: 360,
            //aspectRatio: 1.777777778,
            frameRate: 20,
            facingMode: "environment",
        },
    ],
    ANDROID: [
        {
            width: 1280,
            height: 720,
            aspectRatio: 1.777777778,
            frameRate: 20,
            facingMode: "environment",
        },
        {
            width: 1280,
            height: 720,
            frameRate: 20,
            facingMode: "environment",
        },
        {
            aspectRatio: 1.777777778,
            frameRate: 20,
            facingMode: "environment",
        },
        {
            width: 1280,
            height: 720,
            frameRate: 20,
        },
        {
            width: 1280,
            height: 720,
        },
    ],
    defaultSet: [
        {
            width: 1920,
            height: 1080,
            aspectRatio: 1.777777778,
            frameRate: 20,
            facingMode: "environment",
        },
        {
            width: 1920,
            height: 1080,
            frameRate: 20,
            facingMode: "environment",
        },
        {
            width: 1920,
            height: 1080,
            frameRate: 20,
        },
        {
            width: 1280,
            height: 720,
            frameRate: 20,
            facingMode: "environment",
        },
        {
            aspectRatio: 1.777777778,
            frameRate: 20,
            facingMode: "environment",
        },
        {
            width: 1280,
            height: 720,
            frameRate: 20,
        },
        {
            width: 1280,
            height: 720,
        },
    ],
} as { [index: string]: MediaTrackConstraintSet[] };
